import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import { isDev } from 'config';
import { createLogger } from 'redux-logger';

import rootReducer, { RESET_STORE_ACTION_TYPE } from './rootReducer';

const logger = createLogger({
  collapsed: true,
  duration: true,
});

const middleware = getDefaultMiddleware({
  thunk: true,
  duration: true,
});

if (isDev) {
  middleware.push(logger);
}

const store = configureStore({
  reducer: rootReducer,
  middleware,
  devTools: isDev,
  preloadedState: rootReducer(undefined, { type: RESET_STORE_ACTION_TYPE }),
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export default store;
